import type { I18nKey } from './en';

/** Bengali — partial starter translation; falls back to English. */
export const bn: Partial<Record<I18nKey, string>> = {
  'app.tagline': 'আপনার ছক। আপনার Ally। আপনার মানুষ।',
  'tabs.charts': 'ছক',
  'tabs.messages': 'বার্তা',
  'tabs.profile': 'প্রোফাইল',
  'onb.dob': 'জন্ম তারিখ',
  'onb.place': 'জন্মস্থান',
  'onb.timeStatus': 'আপনার জন্ম সময়',
  'onb.time.exact': 'আমি আমার সঠিক জন্ম সময় জানি',
  'onb.time.approx': 'আনুমানিক সময় বা সীমা জানি',
  'onb.time.unknown': 'জন্ম সময় জানি না',
  'chart.stable': 'আপনার সময়সীমায় স্থির',
  'chart.possible': 'সঠিক সময়ের উপর নির্ভরশীল',
  'chart.unavailable': 'সময় সীমিত না হওয়া পর্যন্ত অনুপলব্ধ',
  'common.continue': 'এগিয়ে যান',
  'common.back': 'ফিরে যান',
};
